import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Deja cada pantalla nueva empezando por su inicio.
 *
 * `BrowserRouter` no reposiciona la pantalla al cambiar de ruta. Eso pasó inadvertido mientras
 * a Aportes y Movimientos se llegaba desde el menú lateral, que es fijo y no obliga a desplazar
 * nada; al pasar a abrirse desde fichas dentro de Balance quedó a la vista: en teléfono hay que
 * bajar la pantalla para alcanzar la ficha, y la pantalla siguiente heredaba ese desplazamiento
 * —se abría por la mitad—. Reportado en el testing manual del PR #237.
 *
 * Solo actúa al navegar hacia adelante. Con el botón "atrás" del navegador (`POP`) se abstiene,
 * para no pisar la restauración del navegador. **Ojo con la expectativa**: medido en teléfono,
 * volver con "atrás" igual aterriza arriba (0), no en la posición previa. No lo causa esta
 * guarda —el navegador intenta restaurar antes de que React haya vuelto a dibujar el contenido,
 * así que no hay altura que restaurar todavía—. Abstenerse sigue siendo lo correcto: el día que
 * se quiera conservar la posición al volver, el arreglo es guardar y reponer el scroll por
 * entrada del historial, y esta guarda es donde engancha. No escribir aquí que "atrás conserva
 * la posición" sin volver a medirlo.
 *
 * Depende solo de `pathname` a propósito: cambiar el período de una pantalla reescribe la
 * consulta de la dirección, y eso no debe mandar al usuario de vuelta arriba.
 */
export function ScrollAlTope() {
  const { pathname } = useLocation();
  const tipoDeNavegacion = useNavigationType();

  useLayoutEffect(() => {
    if (tipoDeNavegacion === 'POP') return;
    globalThis.scrollTo(0, 0);
  }, [pathname, tipoDeNavegacion]);

  return null;
}
